import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=1bbaa641&"
import script from "./UserPermissions.vue?vue&type=script&lang=js&"
export * from "./UserPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports